<template>
  <section class="show-cards">
    <div class="container">
      <div style="display: flex; justify-content: center; margin: 40px 0">
        <div
          class="gredaint-color"
          style="
            display: flex;
            justify-content: center;
            font-family: Roboto, sans-serif;
            border-radius: 30px;
            background: linear-gradient(to right, #05cefc, #5659ce);
            padding: 20px 76px;
            color: white;
          "
        >
          Our Main Categories
        </div>
      </div>
      <div class="row" style="flex-col: 1;">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide
            style="margin-bottom: 20px"
            v-for="cat in colorsAdd"
            v-bind:key="cat._id"
          >
            <div
              style="cursor: pointer"
              @click="navigateCat(cat._id, cat.name)"
            >
              <div
                class="brands-classes"
                v-bind:style="{
                  backgroundImage:
                    'linear-gradient(to right,' +
                    cat.first +
                    ',' +
                    cat.second +
                    ' )',
                }"
              >
                <img
                  class="zoomIn"
                  style="padding: 1px"
                  width="70%"
                  v-bind:src="
                    'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                      cat.image
                  "
                  alt
                />
              </div>
              <h3 style="cursor: pointer">{{ cat.name }}</h3>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin: 40px 0">
      <div
        class="gredaint-color2"
        style="
          display: flex;
          justify-content: center;
          font-family: Roboto, sans-serif;
          border-radius: 30px;
          background: -webkit-gradient(
            linear,
            right top,
            left top,
            from(#ff3fbb),
            to(#ff8891)
          );
          padding: 20px 76px;
          color: white;
        "
      >
        Our Latest Products
      </div>
    </div>
    <div class="row justify-content-start">
      <products-card
        v-for="(product, index) in activeOnce"
        :key="`${index}--INDEX__PRODUCT`"
        :product="product"
        class="custom-width"
      />
    </div>
    <div
      class="view-more text-center"
      style="justify-content: center; display: flex; align-items: center"
    >
      <a
        @click="loadMore"
        type="button"
        style="color: white"
        class="botn botn-blue pt-3"
        >Load more</a
      >
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import router from "../router";
import axios from "axios";

import ProductsCard from "../components/Utilities/Cards/Products.vue";

export default {
  components: {
    Swiper,
    SwiperSlide,
    ProductsCard,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        slidesPerColumn: 2,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          640: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          },
        },
      },
      categories: [],
      colors: [
        { first: "#ff0400", second: "#ffcf69" },
        { first: "#c7f1ff", second: "#00d6ff" },
        { first: "#02b718", second: "#00d6ff" },
        { first: "#f16522", second: "#ffcf69" },
        { first: "#ff2cc6", second: "#ffcf69" },
      ],
      products: [],
      page: 1,
      size: 20,
    };
  },
  computed: {
    activeOnce() {
      return this.products.filter((product) => product.isActive);
    },
    colorsAdd() {
      return this.categories.map((cat) => {
        const randomGradiant = this.colors[
          Math.floor(Math.random() * this.colors.length)
        ];
        const colors = {
          first: randomGradiant.first,
          second: randomGradiant.second,
        };
        Object.assign(cat, colors);
        return cat;
      });
    },
  },
  created() {
    this.getCategories();
    this.getProducts();
  },
  watch: {
    page: function() {
      this.getProducts();
    },
  },
  methods: {
    next() {
      this.page += 1;
    },
    previous() {
      this.page != 1 ? this.page-- : (this.page = 1);
    },
    getProducts() {
      axios
        .get(
          `https://api.ardunic.com/v1/products?p=${this.page}&s=${this.size}`
        )
        .then((res) => (this.products = res.data.data));
    },
    loadMore() {
      this.size = this.size * 2;
      this.getProducts();
    },
    navigateCat(id, name) {
      router.push({ path: `/sub/${name}/${id}` });
      // console.log(slug);
    },
    getCategories() {
      axios.get("https://api.ardunic.com/v1/sections").then((res) => {
        this.categories = res.data.data.filter((product) => product.isActive);
      });
    },
  },
};
</script>

<style scoped>
.custom-width {
  width: 20%;
}
@media screen and (max-width: 1500px) {
  .custom-width {
    width: 25%;
  }
}

@media screen and (max-width: 1200px) {
  .custom-width {
    width: 33.33333%;
  }
}
@media screen and (max-width: 800px) {
  .custom-width {
    width: 50%;
  }
}

@media screen and (max-width: 500px) {
  .custom-width {
    width: 100%;
  }
}

.swiper {
  height: 550px;
  margin-left: auto;
  margin-right: auto;
}
.swiper .swiper-slide {
  height: 200px;
  display: flex;
  justify-content: center;
  text-align: center;
}
.col-md-3 {
  text-align: center;
}

.brands-classes {
  width: 255px;
  height: 180px;
  padding: 15px;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide {
  margin-bottom: 20px;
}

.gredaint-color {
  font-size: 35px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
}
.show-cards {
  margin: 100px 80px 50px 80px;
}

.title-card {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}

.botn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  width: 400px;
  height: 60px;
  font-weight: bold;
}
.botn-blue {
  color: white;
  text-align: center;
  background: linear-gradient(to right, #f6893a, #fdbd5d);
}

.org {
  background: linear-gradient(right, #ff3fbb, #ff8891);
}

.blue {
  background: linear-gradient(to right, #05cefc, #5659ce);
}

.box {
  display: flex;
  justify-content: space-between;
}

.btn {
  border-radius: 15px;
}

.cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.icon-box {
  border-radius: 15px;
  width: 200px;
  height: auto;
}

.icon-box img {
  width: 130px;
  padding: 20px;
}
.buttons-section button {
  margin-right: 20px;
}

.buttons-section {
  margin-bottom: 20px;
}

.items-cards-container {
  display: flex;
  justify-content: space-around;
  border: 1px solid #c1c2c5;
  border-radius: 15px;
  padding: 40px;
  padding-top: 150px;
  margin: -85px 30px 20px 30px;
}
p {
  color: #5659ce;
  font-weight: bold;
}
.botn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  width: 400px;
  height: 60px;
}
.botn-blue {
  color: white;
  text-align: center;
  background: linear-gradient(to right, #05cefc, #5659ce);
}

/* .cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
} */
/* .card {
  flex: 0 0 21%;
  margin-top: 20px;
  border-radius: 25px;
} */

#search-cards-row {
  padding: 0px 36px;
}

@media (max-width: 767px) {
  #search-cards-row {
    padding: 0px;
  }
  #list-col {
    max-width: 100%;
  }
}
.card-buttons {
  display: flex;
  justify-content: space-evenly;
}

/* .card img {
  width: 200px;
} */

.view-more {
  margin-bottom: -65px;
  margin-top: 50px;
}

.card-new {
  margin-bottom: 13px;
  border-radius: 10px;
  padding: 12px 12px;
  overflow: hidden;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.img-new {
  width: 100%;
}

.img-div {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  line-height: 0;
  width: 100%;
  overflow: hidden;
}

.card-img-new {
  max-height: 100%;
  max-width: 100%;
}

.title-new {
  height: auto;
  line-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.price-new {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-span {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  color: #333;
  vertical-align: middle;
  font-weight: 700;
}
</style>
